// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_28-1";
export var rateTableServiceLevelDropdown = "_28-3";
export var rateTableTypeDropdown = "_28-0";
export var rateTableValueModeDropdown = "_28-2";